import { onMounted, shallowRef } from "vue";
import { useTrpc } from "@app/vue/providers/index";

type EntityType = "product" | "extra";

/**
 * Cost per portion of every recipe in the shop (trpc.recipes.costs), for the
 * cost and margin columns. Call reload() after a recipe is saved.
 */
export function useRecipeCosts() {
  const trpc = useTrpc();
  const costs = shallowRef(new Map<string, number>());

  const reload = async () => {
    try {
      const rows = await trpc.recipes.costs.query();
      costs.value = new Map(rows.map((r) => [`${r.entity_type}:${r.entity_id}`, r.cost_per_portion]));
    } catch {
      // Columns just stay empty; the grid itself still works.
    }
  };

  onMounted(reload);

  const costFor = (entityType: EntityType, id: number): number | null =>
    costs.value.get(`${entityType}:${id}`) ?? null;

  return { costs, costFor, reload };
}
